import React from "react";
import { graphql } from "gatsby";
import Layout from "~/components/layout";
import BannerComponent from "../components/banner";
import AnounceComponent from "../components/anounce";
import SubAnounceComponent from "../components/subanounce";
import CardBannerComponent from "../components/cardBanner";
import styled from "styled-components";
import Fade from 'react-reveal/Fade';

const WrapperContent = styled.div``;

const PromotionPage = ({ data }) => {
  const pageName = "live22";
  const bannerList = data.datoCmsLive22.banner;
  const promotionList = data.datoCmsPromotion.live22Promotion;
  const anounce = data.datoCmsAnounceSlider.anounceText;
  const subAnounce = {
    header: data.datoCmsPromotion.live22HeaderPromotion,
    content: data.datoCmsPromotion.live22ContentPromotion,
  }

  return (
    <Layout pageName={pageName}>
      <Fade bottom>
        <BannerComponent
          bannerList={bannerList}
          pageName={pageName} />
      </Fade>
      <WrapperContent className="w-full lg:container mx-auto">
        <Fade bottom>
          <AnounceComponent anounce={anounce} pageName={pageName} />
        </Fade>
        <Fade bottom>
          <SubAnounceComponent subAnounce={subAnounce} pageName={pageName} />
        </Fade>
          <CardBannerComponent data={promotionList} pageName={pageName} />
      </WrapperContent>
    </Layout>
  );
};

export const query = graphql`
  query PromotionPageTemplate {
    datoCmsAnounceSlider {
      anounceText
    }
    datoCmsLive22 {
      banner {
        url(imgixParams: {auto: "format", q: 90})
      }
    }
    datoCmsPromotion {
      live22ContentPromotion
      live22HeaderPromotion
      live22Promotion {
        title
        image {
          url
        }
      }
    }
  }
`;

export default PromotionPage;
